import { IEventFilterContentProps, IEventFilterValue, IEventParameterItem } from "@/pages/dashboard/filterPageComponents/eventAnalysis/EventExplorationFilter/components/EventFilter/components/EventFilterContent/type";
import { getName } from "@home/utils/common";
import { useMemo } from "react";

export const useEventExplorationFilter = ({
  isEN,
  data,
  eventFilterValue,
} : {
  isEN: boolean;
  data: IEventFilterContentProps['data'];
  // 如要使用 getEventParametersOptions，此为必传项
  eventFilterValue?: IEventFilterValue;
}) => {
  const hasData = data && data.length > 0;
  const isEventNameEmpty = !eventFilterValue?.eventName;

  const getEventNameOptions = useMemo(() => {
    if (!hasData) return [];

    return data?.map(item => {
      return {
        value: item?.code,
        text: getName(isEN, item?.name_en, item?.name_ch),
        textEn: item?.name_en,
        textCN: item?.name_ch,
        groupKey: "eventName",
      };
    }) || [];
  }, [isEN, data, hasData]);

  const getEventParametersOptions = useMemo(() => {
    if (!hasData && isEventNameEmpty) return [];

    const selectedEvent = data?.find((item) => item?.code === eventFilterValue?.eventName);
    if (!selectedEvent?.json_str) return [];

    let parameters: IEventParameterItem[] = [];

    try {
      parameters = JSON.parse(selectedEvent.json_str);
    } catch {
      return [];
    }

    return parameters?.map((param) => {
      const paramType = param?.param_type || '';
      const isOperatorType = paramType === 'numeric' || paramType === 'text';
      const hasOptions = !isOperatorType && (param?.options?.length ?? 0) > 0;
      return {
        value: param?.param_key,
        text: getName(isEN, param?.param_name_en, param?.param_name_ch),
        textEn: param?.param_name_en,
        textCN: param?.param_name_ch,
        type: paramType,
        children: hasOptions ? param.options.map((option) => {
          return {
            // 这边不可以直接用后端给的 code，会重复，当传回去的时候需要再次处理
            value: `${param?.param_key}@__@${option.code}`,
            text: getName(isEN, option?.name_en, option?.name_ch),
            textEn: option?.name_en,
            textCN: option?.name_ch,
          };
        }) : undefined,
      };
    }) || [];
  }, [data, eventFilterValue?.eventName, hasData, isEventNameEmpty, isEN]);

  return {
    getEventNameOptions,
    getEventParametersOptions,
  };
};
